import { InjectionToken } from '@angular/core';

export class GaSessionConfigLsKeys {
    session: string;
    serverUrl: string;

    constructor(options?: Partial<GaSessionConfigLsKeys>) {
        this.session = options?.session ?? '';
        this.serverUrl = options?.serverUrl ?? '';
    }
}

export class GaSessionConfig {
    enabled: boolean;
    autorizedUrl: string;
    unautorizedUrl: string;
    serverUrl: string;
    lsKeys: GaSessionConfigLsKeys;

    constructor(options?: Partial<GaSessionConfig>) {
        this.enabled = options?.enabled ?? false;
        this.autorizedUrl = options?.autorizedUrl ?? '';
        this.unautorizedUrl = options?.unautorizedUrl ?? '',
        this.serverUrl = options?.serverUrl ?? '';
        this.lsKeys = options?.lsKeys ?? new GaSessionConfigLsKeys();
    }
}

export const GA_SESSION_CONFIG: InjectionToken<GaSessionConfig[]> = new InjectionToken('GA session config');

export const defaultGaSessionConfig: GaSessionConfig = new GaSessionConfig({
    enabled: false,
    autorizedUrl: '/home/index.html',
    unautorizedUrl: '/signin/index.html',
    serverUrl: '',
    lsKeys: {
        session: 'session',
        serverUrl: 'serverUrl'
    }
});
